import { atom } from 'recoil';

export const setLabworkData = atom({
    key: 'setLabworkData', // unique ID (with respect to other atoms/selectors)
    default: [] // default value (aka initial value)
});  

 